// =======================
// src/paginas/main.js
// =======================

import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { CondicaoContext } from "../contexto";
import TransicaoPagina from "../componentes/comuns/TransicaoPagina";

// Componentes
import RegisterPage from "./telaDeCadastro/cadastro";
import PaginaProcessosEscola from "./paginaEscola/processos/processosEscola";
import PerfilEscolar from "./paginaEscola/perfil/perfilEscolar";
import PaginaProcessos from "./paginaEscola/NovoProcesso/novoProcesso";
import DetalhesProcesso from "./paginaEscola/processos/DetalhesProcesso";

import TelaLogin from "./telaDeLogin/loginpage";
import EsqueciSenhaPage from "./telaDeLogin/EsqueciSenha";
import RedefinirSenhaPage from "./telaDeLogin/RedefinirSenha";

import RegistroEscola from "./paginaEscola/cadastroEscola.js/cadastroescola";
import PaginaProcessosAnalista from "./analise/processos/processosAnalista.js";
import AnalistaPage from "./analise/processos/analiseProcessos.js";
import SchoolProfilesPage from "./analise/escola/listaEscola.js";
import Mantenedoras from "./analise/mantenedora/Mantenedora.jsx";
import InfoEscola from "./analise/escola/detalhesEscola.js";
import InfoMantenedora from "./analise/mantenedora/detalhesMantenedora.js";
import PortariaPage from "./analise/gerarPortaria/portaria.js";
import TelaDeValidacao from "./telaDeCadastro/telaDeValidacao.js";
import RegistrarNovoTipoDeProcesso from "./adminPage/processos/registrarTipoProcesso.js";
import ProcessosCriados from "./adminPage/processos/listProcessType.js";
import EditarProcesso from "./adminPage/processos/atualizarProcess.js";
import CadastroDocumentosPage from "./adminPage/documentos/CadastroDocumentosPage.js";
import Documentos from "./paginaEscola/NovoProcesso/Documentos.js";
import ModalidadesPage from "./adminPage/modalidades/VisualizarModalidade.js";
import CadastroModalidadePage from "./adminPage/modalidades/CriarModalidade.js";
import EdicaoModalidadePage from "./adminPage/modalidades/EditarModalidade.js";
import CadastroEsperaPage from "./analise/autorizarCadastro/autorizaCadastro.js";
import AprovarCadastroPage from "./analise/autorizarCadastro/AprovarCadastroPage.js";
import UsuariosList from "./adminPage/listarUsersPage.js";
import InstituicoesList from "./analise/escola/listMantUsers.js";
import CitiesPage from "./secretaria/citie/CitiesPage.js";
import SREsPage from "./secretaria/sre/SREsPage.js";
import CriarSRE from "./secretaria/sre/CriarSRE.jsx";
import EditarSre from "./secretaria/sre/EditarSre.js";

import TrocarCredenciais from "./secretaria/TrocarCredenciais.jsx";
import ModelosCatalogo from "./modelos/modelosCatalogo.js";
import PainelAdministrador from "./administrador/painelAdministrador";
import CatalogoEnsino from "./administrador/catalogoEnsino/CatalogoEnsino";
import PainelAnalista from "./analista/painelAnalista";
import PainelSuperintendencia from "./secretaria/painelSuperintendencia";
import PainelInstituicao from "./paginaEscola/painelInstituicao";
import PerfilUsuario from "./perfil/perfilUsuario";
import ConfirmarAlteracaoEmail from "./perfil/confirmarAlteracaoEmail";

export default function Rotas() {
  const { condicao, role, firstAccess } = useContext(CondicaoContext);

  return (
    <Routes>
      {/* =====================================================
          CONFIRMAÇÃO DE ALTERAÇÃO DE E-MAIL

          Precisa funcionar com ou sem sessão ativa.
      ===================================================== */}

      <Route
        path="/confirmar-alteracao-email"
        element={<ConfirmarAlteracaoEmail />}
      />

      {!condicao ? (
        <>
          {/* =================================================
              ESCOLA
          ================================================= */}

          {role === "user" && (
            <>
              <Route
                path="/home/painel"
                element={
                  <TransicaoPagina variante="entrada">
                    <PainelInstituicao />
                  </TransicaoPagina>
                }
              />

              <Route
                path="/home/processos"
                element={<PaginaProcessosEscola />}
              />

              <Route path="/home/perfil" element={<PerfilEscolar />} />

              <Route path="/modelos" element={<ModelosCatalogo />} />

              <Route path="/novoProcesso" element={<PaginaProcessos />} />

              <Route path="/novoProcesso/documentos" element={<Documentos />} />

              <Route path="/cadastroEscola" element={<RegistroEscola />} />

              <Route
                path="/detalhes-processo/:processId"
                element={<DetalhesProcesso />}
              />

              <Route
                path="/detalhes-processo/:processId/:schoolName"
                element={<DetalhesProcesso />}
              />
            </>
          )}

          {/* =================================================
              ADMINISTRADOR
          ================================================= */}

          {role === "admin" && (
            <>
              <Route
                path="/admin"
                element={<Navigate to="/admin/painel" replace />}
              />

              <Route
                path="/admin/*"
                element={<Navigate to="/admin/painel" replace />}
              />

              <Route
                path="/admin/painel"
                element={
                  <TransicaoPagina variante="entrada">
                    <PainelAdministrador />
                  </TransicaoPagina>
                }
              />

              <Route path="/admin/perfil" element={<PerfilUsuario />} />

              <Route path="/admin/catalogo-ensino" element={<CatalogoEnsino />} />

              <Route path="/admin/visualizar/cidade" element={<CitiesPage />} />

              <Route
                path="/admin/adicionar/cidade"
                element={<Navigate to="/admin/visualizar/cidade" replace />}
              />

              <Route
                path="/admin/editar/cidade/:id"
                element={<Navigate to="/admin/visualizar/cidade" replace />}
              />

              <Route path="/admin/visualizar/sre" element={<SREsPage />} />

              <Route path="/admin/adicionar/sre" element={<CriarSRE />} />

              <Route path="/admin/editar/sre/:id" element={<EditarSre />} />

              <Route path="/admin/usuarios" element={<UsuariosList />} />
            </>
          )}

          {/* =================================================
              SRE
          ================================================= */}

          {role === "superintendent" && (
            <>
              {firstAccess ? (
                <>
                  <Route
                    path="/trocar-credenciais"
                    element={<TrocarCredenciais />}
                  />

                  <Route
                    path="*"
                    element={<Navigate to="/trocar-credenciais" replace />}
                  />
                </>
              ) : (
                <>
                  <Route
                    path="/admin"
                    element={
                      <TransicaoPagina variante="entrada">
                        <PainelSuperintendencia />
                      </TransicaoPagina>
                    }
                  />

                  <Route
                    path="/admin/processo"
                    element={<ProcessosCriados />}
                  />

                  <Route
                    path="/admin/processo/criar"
                    element={
                      <TransicaoPagina variante="navegacao">
                        <RegistrarNovoTipoDeProcesso />
                      </TransicaoPagina>
                    }
                  />

                  <Route
                    path="/admin/processo/editar/:id"
                    element={
                      <TransicaoPagina variante="navegacao">
                        <EditarProcesso />
                      </TransicaoPagina>
                    }
                  />

                  <Route
                    path="/admin/cadastro-documento"
                    element={
                      <TransicaoPagina variante="navegacao">
                        <CadastroDocumentosPage />
                      </TransicaoPagina>
                    }
                  />

                  <Route
                    path="/admin/visualizar/modalidade"
                    element={<ModalidadesPage />}
                  />

                  <Route
                    path="/admin/adicionar/modalidade"
                    element={<CadastroModalidadePage />}
                  />

                  <Route
                    path="/admin/editar/modalidade/:id"
                    element={<EdicaoModalidadePage />}
                  />

                  <Route path="/admin/usuarios" element={<UsuariosList />} />

                  <Route path="/modelos" element={<ModelosCatalogo />} />

                  <Route
                    path="/trocar-credenciais"
                    element={<TrocarCredenciais />}
                  />
                </>
              )}
            </>
          )}

          {/* =================================================
              ANALISTA
          ================================================= */}

          {role === "analyst" && (
            <>
              <Route
                path="/analista/painel"
                element={
                  <TransicaoPagina variante="entrada">
                    <PainelAnalista />
                  </TransicaoPagina>
                }
              />

              <Route path="/analise" element={<PaginaProcessosAnalista />} />

              <Route
                path="/analise_cadastro"
                element={<CadastroEsperaPage />}
              />

              <Route
                path="/escolas-geral"
                element={
                  <TransicaoPagina variante="navegacao">
                    <SchoolProfilesPage />
                  </TransicaoPagina>
                }
              />

              <Route
                path="/processo-detalhado/:escola/:id"
                element={<AnalistaPage />}
              />

              <Route
                path="/processo-detalhado/:id"
                element={<AnalistaPage />}
              />

              <Route path="/perfil-escola/:id" element={<InfoEscola />} />

              <Route
                path="/perfil-mantenedora/:id"
                element={<InfoMantenedora />}
              />

              <Route
                path="/mantenedora"
                element={
                  <TransicaoPagina variante="navegacao">
                    <Mantenedoras />
                  </TransicaoPagina>
                }
              />

              <Route path="/portaria" element={<PortariaPage />} />

              <Route
                path="/aprovar-cadastro/:tipo/:id"
                element={<AprovarCadastroPage />}
              />

              <Route path="/listar/users" element={<InstituicoesList />} />

              <Route path="/modelos" element={<ModelosCatalogo />} />
            </>
          )}
        </>
      ) : (
        <>
          {/* =================================================
              ROTAS PÚBLICAS
          ================================================= */}

          <Route path="/login" element={<TelaLogin />} />

          <Route path="/esqueci-senha" element={<EsqueciSenhaPage />} />

          <Route
            path="/redefinir-senha/:token"
            element={<RedefinirSenhaPage />}
          />

          <Route path="/cadastro" element={<RegisterPage />} />

          <Route path="/cadastro-sucesso" element={<TelaDeValidacao />} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      )}
    </Routes>
  );
}
